export default __webpack_public_path__ + "static/media/glrc-course.bountiful-bread.cdbfcaa8.png";